import { gql } from '@apollo/client';

export const GET_HISTORICAL_OVERRIDE_SCHEDULED_IMPORTS = gql`
    query GetHistoricalOverrideScheduledImports($input: GetImportLogsInput!) {
        getManualImportLogs(input: $input) {
            total
            logs {
                id
                fileName
                status
                createdAt
                scheduledFor
                createdBy {
                    id
                    firstName
                    lastName
                    email
                }
            }
        }
    }
`;
